module.exports = __webpack_public_path__ + "img/btn-plus.27de0e23.svg";